import { Placeholder, PlaceholderLine, PlaceholderMedia, Shine } from 'rn-placeholder';
import { Card, ScrollView, Stack, View } from 'tamagui';

export const HomePlaceHolder = () => {
  return (
    <>
      <ScrollView showsVerticalScrollIndicator={false} backgroundColor={'#FFF'}>
        <Card
          width={'100%'}
          shadowColor={'#000000'}
          shadowRadius={5}
          elevation={5}
          margin={5}
          shadowOpacity={0.2}
          marginTop={70}
          paddingTop={20}
          paddingHorizontal={15}
          backgroundColor="$background"
        >
          <Placeholder Animation={Shine}>
            <PlaceholderLine width={80} />
            <Stack width={160} display="flex" flexDirection="row" justifyContent="space-between">
              <PlaceholderLine
                width={80}
                style={[{ width: 160, height: 45, borderRadius: 10, marginRight: 10 }]}
              />
              <PlaceholderLine width={80} style={[{ width: 160, height: 45, borderRadius: 10 }]} />
            </Stack>
          </Placeholder>
        </Card>
        <View style={{ flex: 1, flexDirection: 'column' }}>
          <Card
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            marginHorizontal={5}
            shadowOpacity={0.2}
            marginVertical={10}
            backgroundColor="$background"
          >
            <Stack padding={10} width={160} display="flex" flexDirection="row">
              <Placeholder Animation={Shine}>
                <PlaceholderMedia style={[{ width: 160, height: 260, marginTop: 10 }]} />
              </Placeholder>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia
                  style={[{ width: 150, height: 260, marginLeft: 50, marginTop: 10 }]}
                />
              </Placeholder>
            </Stack>
          </Card>
        </View>
        <View style={{ flex: 1 }}>
          <Card
            shadowColor={'#000000'}
            shadowRadius={5}
            elevation={5}
            marginHorizontal={5}
            shadowOpacity={0.2}
            marginVertical={10}
            backgroundColor="$background"
          >
            <Stack padding={10}>
              <Placeholder
                Animation={Shine}
                Left={(props) => <PlaceholderMedia isRound={true} style={[props.style]} />}
              >
                <PlaceholderLine width={80} />
                <PlaceholderLine width={30} />
              </Placeholder>
              <Placeholder Animation={Shine}>
                <PlaceholderMedia
                  style={[{ width: 300, height: 250, marginLeft: 25, marginTop: 10 }]}
                />
              </Placeholder>
            </Stack>
          </Card>
        </View>
      </ScrollView>
    </>
  );
};
